import { all, call, put, select } from "redux-saga/effects"
import api from "apis"
import { updateTrackingInfo } from "../actions"

export default function* fetchTrackingInfo(action) {
  const result = yield api.get("/orders/track?order_id=" + action.order_id)
  yield put(updateTrackingInfo(result))
}
